<script>
// @ is an alias to /src
import { Donuz } from "@/donuz-js/Donuz";

export default {
  name: "app",
  data() {
    return {
      client: false,
      configs: {},
      loading: true
    };
  },
  async created() {
    M.AutoInit();
    localStorage.setItem("estabelishment", this.ESTABELECIMENTO.id);
        let directAccess = this.$route.params.data.split('--');
        let emailUsr = atob(directAccess[1]);
        let validUsr = atob(directAccess[2]);
        let pageUsr = atob(directAccess[3]);
        let date= new Date();
        if (date.toISOString().slice(0,date.toISOString().indexOf('T')) > validUsr) {
            this.$route.push(this.$route.params.slug+'/')
        }

        if (is_null(emailUsr)) {
            this.$route.push(this.$route.params.slug+'/')
        }

        let result = Donuz.custumer.signInByEmail(emailUsr,this.ESTABELECIMENTO.id) 
        if(result.status==200){
            let client = result.clientes[0]
            let saldo = await Donuz.balance.getCustomerBalance(result.token,this.ESTABELECIMENTO.id);
            client.saldo = parseFloat(saldo.saldo)
            .toFixed(2)
            .replace(".", ",");
            sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
            sessionStorage.setItem(btoa("tokenCliente"), result.token);
        }

        this.$route.push(this.$route.params.slug+'/meus-presentes')
  }
};
</script>
